// extracted by mini-css-extract-plugin
export var layoutContainer = "_51-0";
export var layoutContainerNoRounding = "_51-6";
export var layoutContainerOpen = "_51-5";
export var layoutContainerResizing = "_51-1";
export var mainContent = "_51-2";
export var resizeDivider = "_51-3";
export var slidePanel = "_51-4";